import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../helpers/translate.helper';
import { IconUserCircle } from '../../icons/cdl/UserCircle';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const OpenPersonalDetails = () => {
    const navigate = useNavigate();
    const { setOpen } = useShortcutMenu();

    return (
        <CommandItem
            onSelect={() => {
                navigate({ to: '/me' });
                setOpen(false);
            }}
            Icon={IconUserCircle}
        >
            {translate('navigation.personalDetails')}
        </CommandItem>
    );
};
